import React from 'react'
import { flowRight } from 'lodash'
import { useTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { getLocale } from 'lib/utils/getLocale'

import ControlledModal from 'components/Modal/ControlledModal'
import Link from 'components/Link'

import './bos-process-info-modal.pcss'

const BosProcessInfoModal = ({ match }) => {
    const { t, i18n } = useTranslation(['serviceProcessDiagram'])
    const { processStateId, currentUserRole } = match.params

    const processDiagramKeys = {
        DRAFT: 0,
        SIGNING: 1,
        PAYMENT: 2,
        TRANSFERRAL: 3,
        CONFIRMATION: 4,
        COMPLETION: 5
    }

    const processSections = t('sections', { returnObjects: true })

    const getProcessSection = (index) => {
        if (!processSections) return null

        if (!processSections[index]) return null

        return processSections[index]
    }

    const participantLabels = (participantKeys) => {
        return (
            <div className="participant-labels">
                {participantKeys.map((p, i) =>
                    <div key={i} className={`participant-label participant-label--${p}`}>{t(`participant.${p}`)}</div>
                )}
            </div>
        )
    }

    const renderInfo = () => {
        let displayProcessStateId = processStateId.toUpperCase()

        if (currentUserRole === 'seller' && processStateId === 'COMPLETION') {
            displayProcessStateId = 'CONFIRMATION'
        }

        const processSection = getProcessSection(processDiagramKeys[displayProcessStateId])

        const items = processSection.items.map((item, i) => (
            <div key={i} className="service-process-diagram__item">
                {item.participantKeys && participantLabels(item.participantKeys)}

                <div className="service-process-diagram__item__content">
                    {item.content && item.content.map((paragraph, i) => <p key={i}>{paragraph}</p>)}
                </div>
            </div>
        )
        )

        return (
            <div className="service-process-diagram__section">
                {items}
            </div>
        )
    }

    return (
        <ControlledModal
            routedModal
            name="bos-process-info-modal"
            context="bosProcessInfoModal"
            initialTitle={processSections[processDiagramKeys[processStateId.toUpperCase()]].title}
            okButtonTxt="Sulje"
            requireUserInput={false}
            closeOnRouteChange={false}
            buttons={[
                <Link
                    key="service-process"
                    to={`${getLocale(i18n.language)}/fiksut-kaupat/kaupan-vaiheet`}
                    target="_blank"
                    className="button button--secondary"
                    trackName="serviceProcess"
                >
                    Avaa ohjesivu
                </Link>
            ]}
        >
            {renderInfo()}
        </ControlledModal>
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
    withRouter,
)(BosProcessInfoModal)
